import * as Yup from 'yup';
import {
  is_account_name_unique,
  is_api_key_unique,
  is_cefi_provider_unique,
} from '../../services/account';
import debounce from 'lodash.debounce';

function addExchangeValidation() {
  const schema = Yup.object().shape({
    exchangeName: Yup.string()
      .required('Exchange name is required')
      .test('exchangeName', 'Exchange name must be unique', async (name) => {
        if (name) {
          const response = await debouncedApiName(name?.trim());
          if (!response) return true;
          return response?.data?.data?.unique;
        }
      }),
    provider: Yup.array()
      .required('Exchange provider is required')
      .test('unique_provider', 'Exchange provider must be unique', async (provider) => {
        if (provider) {
          const response = await debouncedCefiProvider(provider);
          if (!response) return true;
          return response?.data?.data?.unique;
        }
      }),
    apiKey: Yup.string()
      .required('API key is required')
      .test('unique_apiKey', 'Exchange provider must be unique', async (apiKey) => {
        if (apiKey) {
          const response = await debouncedAPIKey(apiKey?.trim());
          if (!response) return true;
          return response?.data?.data?.unique;
        }
      }),
    apiSecret: Yup.string().required('Exchange secret is required'),
    memo: Yup.string().required('Memo is required'),
  });

  return schema;
}

const debouncedApiName = debounce(is_account_name_unique, 500);

const debouncedCefiProvider = debounce(is_cefi_provider_unique, 500);

const debouncedAPIKey = debounce(is_api_key_unique, 500);

export { addExchangeValidation };
